import React from "react";

export default function PageHeader({ eyebrow, title, description, actions, testid }) {
    return (
        <div
            data-testid={testid}
            className="mb-8 flex flex-col gap-4 border-b border-zinc-200 pb-6 md:flex-row md:items-end md:justify-between"
        >
            <div>
                {eyebrow ? (
                    <div className="mb-2 text-[10px] font-semibold uppercase tracking-[0.22em] text-zinc-500">
                        {eyebrow}
                    </div>
                ) : null}
                <h1 className="font-['Outfit'] text-3xl font-semibold tracking-tight text-zinc-900 md:text-4xl">
                    {title}
                </h1>
                {description ? (
                    <p className="mt-2 max-w-2xl text-sm text-zinc-600">{description}</p>
                ) : null}
            </div>
            {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
        </div>
    );
}
